import { useAuth } from '@berky/auth'
import { LoadingSkeleton } from '@berky/ui'
import { Navigate } from 'react-router'
import { PLATFORM_ADMIN_ROLE } from './api'
import { roleAccess } from '../module-access'
import { PermissionWorkspace } from './permission-workspace'

export function VerwaltungPage() {
  const { user, isLoading } = useAuth()
  const access = roleAccess(user?.roles, [PLATFORM_ADMIN_ROLE])
  if (isLoading || access === 'unbekannt')
    return <LoadingSkeleton variant="text" rows={4} />
  if (access !== 'erlaubt')
    return <Navigate to="/forbidden" replace state={{ moduleTitle: 'Verwaltung' }} />
  return <PermissionWorkspace />
}
